import { useLocation, useNavigate } from "react-router-dom";
// material
import { Typography, Button, Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
// components
import AddIcon from "@mui/icons-material/Add";
import Page from "../../Page";
import LeaveDetailsPage from "../../../pages/SidebarMenus/LeaveMenu/LeaveDetailsPage";
import StickyHeader from "../../Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    // padding: theme.spacing(1, 1)
}));
export default function LeaveAnalysis() {
    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate('/dashboard/newissue');

    }

    return (
        <Page title="Leave Management| tiketic" >
            <StickyHeader
                title="Leave Management"
                showButton={false}
                onButtonClick={handleNavigate}
                rightContent={
                    <Stack direction="row" spacing={1} alignItems="center" mt={'2px'}>
                        <Button
                            variant="outlined"
                            sx={{
                                color: "#0062FF",
                                backgroundColor: "#FFFFFF",
                                border: "1px solid #D0DBFF",
                                fontSize: '12px',
                                fontWeight: 500,
                                "& .MuiButton-startIcon": { mr: "2px" },
                                "&:hover": {
                                    backgroundColor: "#155DFC",
                                    color: "#FFFFFF",
                                    border: "1px solid #155DFC",

                                },
                                whiteSpace: "nowrap",
                                textTransform: "none",
                            }}
                        >
                            Absent List
                        </Button>
                        <Button
                            variant="outlined"
                            sx={{
                                color: "#0062FF",
                                backgroundColor: "#FFFFFF",
                                border: "1px solid #D0DBFF",
                                fontSize: '12px',
                                fontWeight: 500,
                                "& .MuiButton-startIcon": { mr: "2px" },
                                "&:hover": {
                                    backgroundColor: "#155DFC",
                                    color: "#FFFFFF",
                                    border: "1px solid #155DFC",

                                },
                                whiteSpace: "nowrap",
                                textTransform: "none",
                            }}
                        >
                            List Of Holidays
                        </Button>
                    </Stack>
                }
            />

            <ContentStyle>
                <LeaveDetailsPage />
            </ContentStyle>

        </Page>
    );
}

